const style = {
  loginForm: {
    marginBottom: "1.5rem",
  },
  loginFormItem: {
    borderRadius: 12,
    border: "2px solid #e8ecef",
    transition: "all 0.3s ease",
  },
  Input: {
    borderRadius: "12px",
    fontSize: "1rem",
    padding: "12px 16px",
  },
};
export default style;
